import { RouterV2Enum } from '@/router/router-names';
import { local, session } from '@/shared/utils/storage';
import { SessionEnum } from '@/enums/session';
import { Component, Vue } from 'vue-property-decorator';
import type { ApplyChooseList } from '@/views_v2/pre-apply-choose/types';
import SuperMemberCard from '@/views_v2/pre-apply-choose/components/super-member-card';

/**
 * 用户是否已跳转了授信结果
 * 用于从结果页back返回链路时（当前仅限-小程序），location.replace会无效重新进入，需依次强制回退首页
*/
export const USER_HAS_JUMPED_OUT_PAGE_KEY = 'user_has_jumped_out_page';

@Component
export default class preApplyResult extends Vue {
  /** 用户是否已有授信结果，以是否已进入授信结果页为判断依据 */
  public userHasJumpedCreditResult = false;

  /** 购买状态 */
  protected async checkSatusAndBuyRight(taskId: number | string): Promise<void> {
    const needBuySuperMember = SuperMemberCard && SuperMemberCard.needBuySuperMemberCard();

    // 如果同意并需要购买超级会员，预下单超级会员
    if (needBuySuperMember) {
      try {
        await SuperMemberCard.buyRights(String(taskId));
      } catch (err) {
        // catch error and report error
        this.$ubtModuleExposeNew('finance_loan_credit_memberOrder', {
          errormsg: JSON.stringify(err),
        });
      }
    }
  }

  // 跳转至授信结果页面
  protected async goResult(taskId: number | string): Promise<void> {
    local.set(SessionEnum.preApplyTaskId, taskId);

    if (taskId) {
      // 非极简流程，在跳转结果页前预下单会员权益
      // 极简流程因发生页面跳转在此处不会预下单，而是在极简流程中处理
      await this.checkSatusAndBuyRight(taskId);
    }
    /** 设置已进入授信结果的标志 */
    this.userHasJumpedCreditResult = true;
    /** 设置已进入授信结果的标志，用于back回退兼容小程序 */
    session.set(USER_HAS_JUMPED_OUT_PAGE_KEY, 1);

    this.$router.replace({
      path: RouterV2Enum.preApplyResult,
      query: {
        taskId: String(taskId),
      },
    });
  }

  /**
   * 协议获取前置判断,若命中则跳转至其他页面，并需要阻止流程的后续方法，所以Promise.reject()出去
   */
  protected preCheckWithShowAgreements = (applyChooseList: ApplyChooseList): Promise<void> => {
    const { taskId } = applyChooseList || {};

    // 有分配的渠道 去渠道结果
    if (taskId) {
      this.goResult(taskId);
      return Promise.reject();
    }
    return Promise.resolve();
  }
}
